(ns frontend.view.grid.common.events
  (:require
    [frontend.tenant-customizations :as tenant-customizations]
    [common.attribute :as attribute]
    [common.localization :as loc]
    [frontend.state.current-session :as session]
    [frontend.zap-time :as zap-time]
    [frontend.exports.excel :as excel]
    [frontend.utils :as fu]
    [common.util :as cu]
    [common.date-formats :as date-formats]
    [common.timezones :as timezones]))


(defn get-export-with-persons-data
  [data]
  (let [data-entity (get @session/entities (:db/id data))
        person-associations
        (->> data-entity
             :common/related-entities
             (map (partial get @session/entities))
             (cu/only-entity :entity.type/entity-association)
             (keep (fn [association]
                     (let [other-entity-id (if (= (:db/id data-entity)
                                                  (:entity-association/target-entity association))
                                             (:entity-association/source-entity association)
                                             (:entity-association/target-entity association))
                           other-entity (get @session/entities other-entity-id)]
                       (when (= :entity.type/person (:entity/type other-entity))
                         [other-entity association])))))]
    (if (empty? person-associations)
      [data]
      (->> person-associations
           (map (fn [[person association]]
                  (let [data-entity-id (:db/id data-entity)
                        association-source-id (:entity-association/source-entity association)
                        entity-comment-key (if (= data-entity-id association-source-id)
                                             :entity-association/target-comment
                                             :entity-association/source-comment
                                           )
                        person-comment-key (if (= data-entity-id association-source-id)
                                             :entity-association/source-comment
                                             :entity-association/target-comment)
                        comments (merge
                                  {:person-comment       (get association person-comment-key)
                                   :other-entity-comment (get association entity-comment-key)})]
                    (merge data
                           (select-keys person
                                        (concat [:person/first-name :person/last-name
                                                 :person/universal-email-address
                                                 :person/universal-phone-number :person/tag-tags]
                                                (when (= @session/tenant-id 17592194668280) ;;Hardcoded by id
                                                  [:person/opt-17592194668280-language
                                                   :person/opts-17592194668280-contact-interests])))
                           (select-keys association [:entity-association/type])
                           comments))))))))

(defn export-with-contacts-data
  [{:keys [entity-type grid-entities-atom column-keys]}]
  (let [cols
        (concat (->> (concat column-keys
                             [:person/first-name :person/last-name :person/universal-email-address
                              :person/universal-phone-number :entity-association/type]
                             (when (= @session/tenant-id 17592194668280) ;;Hardcoded by id
                               [:person/opt-17592194668280-language
                                :person/opts-17592194668280-contact-interests]))
                     (map (fn [c]
                            [c (attribute/attribute-label @session/tenant-schema c)])))
                [[:other-entity-comment (loc/tr :other-entity-comment [(loc/tr entity-type)])]
                 [:person-comment (loc/tr :person-comment)]])
        tag-ids (->> (session/named-values :person/tag-tags)
                     (remove :common/disabled?)
                     (remove :common/archived?)
                     ;; no need to remove pipeline specific options as this is not pipeline entity
                     (map :db/id)
                     (doall))
        selected-item-ids (when-not (= (:selected @grid-entities-atom) :all)
                            (some->> (:selected @grid-entities-atom)
                                     (map (fn [[k s]]
                                            (when s
                                              k)))))
        sorted-entities (:sorted-kanban-entities @grid-entities-atom)
        export-entities (or (when (and (coll? selected-item-ids)
                                       (seq selected-item-ids))
                              (->> sorted-entities
                                   (filter (fn [entity]
                                             (some #{(:db/id entity)} selected-item-ids)))))
                            sorted-entities)
        export-datas (->> export-entities
                          (map get-export-with-persons-data))
        todays-date (fu/display-date-timestamp (zap-time/now))]
    (excel/export-entities-with-person-tags (loc/tr :export-filename-generic
                                                [(loc/tr entity-type) todays-date])
                                            cols
                                            tag-ids
                                            (count export-entities)
                                            export-datas)))


(defn toggle-hide-empty-groups!
  [kanban-state]
  (swap! kanban-state update :hide-all-empty-groups? not)
  (deref kanban-state)
  nil)


(defn export-data
  [{:keys [entity-type resolve-column-keys grid-entities-atom]}]
  (let [cols (into [] (resolve-column-keys))
        selected-item-ids (when-not (= (:selected @grid-entities-atom) :all)
                            (some->> (:selected @grid-entities-atom)
                                     (map (fn [[k s]]
                                            (when s
                                              k)))))
        sorted-entities (:sorted-kanban-entities @grid-entities-atom)
        export-entities (or (when (and (coll? selected-item-ids)
                                       (seq selected-item-ids))
                              (->> sorted-entities
                                   (filter (fn [entity]
                                             (some #{(:db/id entity)} selected-item-ids)))))
                            sorted-entities)
        todays-date (date-formats/format-millis (zap-time/now)
                                                (or (:tenant/date-format @session/tenant)
                                                    (loc/tr :date-format))
                                                (or (:tenant/timezone @session/tenant)
                                                    timezones/default-timezone))]
    (excel/export-entities (loc/tr :export-filename-generic [(loc/tr entity-type) todays-date])
                           cols
                           (count export-entities)
                           nil
                           export-entities)))
